import { render, staticRenderFns } from "./yuesao.vue?vue&type=template&id=6deda18a&scoped=true&lang=html&"
import script from "./yuesao.vue?vue&type=script&lang=js&"
export * from "./yuesao.vue?vue&type=script&lang=js&"
import style0 from "./yuesao.vue?vue&type=style&index=0&id=6deda18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deda18a",
  null
  
)

export default component.exports